import { BaseContainerModel } from '../../base-container.model';
import * as fromDatatype from "../../../datatype-library/index";
import { bl_inv_batch_hdr_RowInterface } from '../../../dbschema';

export class StockAvailabilityOutputDtoModel extends BaseContainerModel {
    inv_item_guid: fromDatatype.GuidDataFieldInterface;
    location_guid: fromDatatype.GuidDataFieldInterface;
    server_doc_type_1: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_2: fromDatatype.VarcharDatatypeInterface;
    qty_balance: fromDatatype.NumericDatatypeInterface;
    qty_reserved: fromDatatype.NumericDatatypeInterface;
    qty_adjustment: fromDatatype.NumericDatatypeInterface;
    qty_signum: fromDatatype.NumericDatatypeInterface;
    qty_available: fromDatatype.NumericDatatypeInterface;
    company_qty_balance: fromDatatype.NumericDatatypeInterface;
    item_code: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    location_code: fromDatatype.VarcharDatatypeInterface;
    comp_guid: fromDatatype.VarcharDatatypeInterface;
    comp_code: fromDatatype.VarcharDatatypeInterface;
    ma_cost: fromDatatype.NumericDatatypeInterface;
    unit_cost_ma: fromDatatype.NumericDatatypeInterface;
    last_purchase_cost: fromDatatype.NumericDatatypeInterface;
    company_ma_cost: fromDatatype.NumericDatatypeInterface;
    company_unit_cost_ma: fromDatatype.NumericDatatypeInterface;
    company_last_purchase_cost: fromDatatype.NumericDatatypeInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    sub_type: fromDatatype.VarcharDatatypeInterface;
    fi_item_guid: fromDatatype.GuidDataFieldInterface;
    serialNumbers: string[];
    bl_inv_batch_hdr: bl_inv_batch_hdr_RowInterface[];
    fifo_cost: fromDatatype.NumericDatatypeInterface;
    lifo_cost: fromDatatype.NumericDatatypeInterface;
    scan_code: fromDatatype.VarcharDatatypeInterface;
}